const LeftToRightBlockQuoteIcon = /*#__PURE__*/ [
  ["path", { d: "M9 6L17 6", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 12L19 12", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 18L17 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 3L5 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export { LeftToRightBlockQuoteIcon as default };
//# sourceMappingURL=LeftToRightBlockQuoteIcon.js.map
